import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from './global';
import { Plato } from '../models/plato';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {

  constructor(
    private http: HttpClient
  ) { }

  // OBTENER INFO DE PLATO DESDE LARAVEL
  crearPedido(pedido: any): Observable<any> {
    console.log(pedido);
    const json = JSON.stringify(pedido);
    const params = json;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(GLOBAL.urlApi + 'pedido/crear', params, { headers });
  }

  /*asociarPedido(model: any): Observable<any> {
    const json = JSON.stringify(model);
    const params = json;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(GLOBAL.urlApi + 'pedido/asociar', params, { headers });
  }*/

  
  getPedido(token: string): Observable<any> {
    const json = {
      token: token
    };
    const params = JSON.stringify(json);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(GLOBAL.urlApi + 'pedido/getByToken', params, { headers });
  }

}
